import { render, staticRenderFns } from "./ModalPageUnidadeAdministrativa.vue?vue&type=template&id=725760ac"
import script from "./ModalPageUnidadeAdministrativa.vue?vue&type=script&lang=js"
export * from "./ModalPageUnidadeAdministrativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports